module.exports = __webpack_public_path__ + "media/src/images/icons/agreement/blue-36fb0154dd7e56a517bb213cd68c2af7.svg";